import { env } from '~/config/env';

function goTo(url: string) {
  window.location.assign(url);
}

export const ROUTES = {
  AUTH: {
    SIGN_IN: '/auth/sign-in',
    VERIFY: '/auth/verify',
    SIGN_UP: '/auth/sign-up',
    SIGN_OUT: '/auth/sign-out',
    RECOVERY: '/auth/recovery',
    ONBOARDING: {
      ROOT: '/auth/onboarding',
      EXAM_DATE: '/auth/onboarding/exam',
      DAILY_GOAL: '/auth/onboarding/daily-goal',
      UNIVERSITY: '/auth/onboarding/university',
      AVATAR: '/auth/onboarding/avatar',
    },
    OAUTH: ({ provider }: { provider: 'apple' | 'google' | 'facebook' }) =>
      `/auth/${provider}`,
  },
  LEGAL: {
    PRIVACY_POLICY: `${env.VITE_APP_URL}/legal/privacy-policy`,
    TERMS_OF_SERVICE: `${env.VITE_APP_URL}/legal/terms-of-service`,
  },
  DECKS: {
    BROWSE: '/decks',
    DECK: ({ id }: { id: number }) => `/decks/${id}`,
  },
  EXAMS: {
    BROWSE: '/exams',
    CREATE: '/exams?create=true',
    DECK: ({ id }: { id: number }) => `/exams/${id}`,
  },
  PROFILE: '/profile',
  SOLVE: {
    DECK: ({ id }: { id: number }) => `/solve/${id}`,
    FREE: ({ id }: { id: number }) => `/solve-free/${id}`,
  },
  RETAKE: '/retake',
  LANDING: {
    MAIN: env.VITE_APP_URL,
    HERO: `${env.VITE_APP_URL}#hero`,
    REVIEWS: `${env.VITE_APP_URL}#reviews`,
    PRICING: `${env.VITE_APP_URL}#pricing`,
    CATEGORIES: `${env.VITE_APP_URL}#categories`,
    MOBILE_APP: `${env.VITE_APP_URL}#mobile-app`,
  },
  ADMIN: {
    PROMO_DECKS: '/admin/promo-decks',
    REVIEW: {
      BROWSE: '/admin/review',
      DECK: ({ id }: { id: number }) => ({
        BROWSE: `/admin/review/${id}`,
        SET: ({ id: setId }: { id: number }) => ({
          VIEW: `/admin/review/${id}/${setId}`,
          QUESTION: ({ id: questionId }: { id: number }) =>
            `/admin/review/${id}/${setId}?q=${questionId}`,
        }),
      }),
    },
    FEEDBACK: '/admin/feedback',
    PREMIUM: '/admin/premium',
    USERS: '/admin/users',
    MCQ: '/admin/mcq',
  },
  NOT_FOUND: '/404',
};
